export class SimpleAttributeModel {
    key: string
    value?: string
    type: string
    attributes?: SimpleAttributeModel[]

    constructor() {
        this.attributes = []
    }
}